module.exports = __webpack_public_path__ + "static/media/icon_equal_to.995a28ce.svg";